import styled from 'styled-components';
import BasicButton from '../Basic/BasicButton';

const TertiaryButton = styled(BasicButton)`
  background-color: transparent;
`;

export default TertiaryButton;
